import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEO({ title, description, keywords }) {
  const siteTitle = 'NCLC 2026';
  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || 'National Conference on Liquid Crystals 2026'} />
      <meta name="keywords" content={keywords || 'NCLC, Liquid Crystals, Conference, 2026'} />
    </Helmet>
  );
}
